module.exports = {"last_5min":"过去五分钟","last_hour":"过去一小时","last_three_hour":"过去三小时","last_six_hour":"过去六小时","last_day":"过去一天","last_seven_day":"过去七天","last_month":"上个月","this_month":"本月至今","custom":"自定义","search":"搜索","selectServerNameText":"域名","selectAppProfileNameText":"专案","selectOriginText":"源站","selectServiceGroupText":"站点","selectedGroupNameText":"群组","selectAppProfileText":"服务","selectedSlbNameText":"SLB","selectedEdgeNameText":"EDGE"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/home.json
// module id = AKuI
// module chunks = 3